import { RangeInfo } from 'src/app/shared/models';

export class YearsRangeFilterData {
  static getInitGraduationRange(): RangeInfo {
    return {
      start: 1900,
      finish: new Date().getFullYear(),
    };
  }
}
